import React, {useEffect, useState} from 'react';
import cookie from 'react-cookies';
import {withFirestore} from 'react-firestore';

import {bbox, lineDistance, lineString} from '../utils/map';
import {getControlById, getPrevisionInicioDistancia} from '../utils/time';
import SharePanel from '../components/SharePanel';
import TopHeaderMenu from '../components/TopHeaderMenu';
import MsgNetLoading from '../components/MsgNetLoading';
import ControlSelector from '../components/ControlSelector';
import ResultadoFavoritosList from '../components/ResultadoFavoritosList';
import CompeticionHeaderMenu from '../components/CompeticionHeaderMenu';

/**
 *
 * @param history
 * @param match
 * @param firestore
 * @returns {*}
 * @constructor
 */
function FavoritosScreen2 ({history, match, firestore}) {
  const [evento, setEvento] = useState(null)
  const [competicion, setCompeticion] = useState({
    mapa_geojson: null,
    mapa_visible: null
  })
  const [competicionId, setCompeticionId] = useState(null)
  const [sectores, setSectores] = useState([])
  const [sectoresFiltrados, setSectoresFiltrados] = useState([])
  const [geoJson, setGeoJson] = useState(null)
  const [turfLine, setTurfLine] = useState(null)
  const [turfBounds, setTurfBounds] = useState(null)
  const [turfDistanceRelation, setTurfDistanceRelation] = useState(1.0)
  // const [favoritos, setFavoritos] = useState([])
  const [controles, setControles] = useState([])
  const [controlMeta, setControlMeta] = useState({
    distancia: 0
  })
  const [resultados, setResultados] = useState([])
  const [showSharePanel, setShowSharePanel] = useState(false)

  const toogleSharePanel = () => {
    setShowSharePanel(!showSharePanel)
  }

  const onClickBack = () => {
    history.push(`/${competicion.evento_id}`)
  }

  /**
   * Listen competición updates depending on route changes
   */
  useEffect(() => {
    const competicionId = parseInt(match.params.competicionId, 10)
    return firestore.doc('competicion/' + competicionId).onSnapshot(snapshot => {
      let competicion = snapshot ? snapshot.data() : null
      if (competicion) {
        competicion.id = snapshot.id
      }
      setCompeticion(competicion)
      setCompeticionId(parseInt(competicion.id, 10))
    })
  }, [match.params.competicionId])

  /**
   * Listen event updates depending on competition changes
   */
  useEffect(() => {
    if (competicion && competicion.evento_id) {
      return firestore.doc('evento/' + competicion.evento_id).onSnapshot(snapshot => {
        let evento = snapshot ? snapshot.data() : null
        if (evento) {
          evento.id = snapshot.id
        }
        setEvento(evento)
      })
    }
  }, [competicionId])

  /**
   * Listen control changes depending on competition changes
   */
  useEffect(() => {
    return firestore.collection('control/')
      .where('competicion_id', '==', competicionId)
      .where('visible', '==', true)
      .orderBy('distancia', 'asc')
      .onSnapshot((snapshot) => {
        const data = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }))
        setControles(data)
        // ...
        let meta = data.filter(c => c.tipo === 'META')
        if (meta.length) {
          setControlMeta(meta[0])
        } else {
          setControlMeta(null)
        }
      })
  }, [competicionId])

  /**
   * Listen sector changes depending on competition changes
   */
  useEffect(() => {
    return firestore.collection('sector/')
      .where('competicion_id', '==', competicionId)
      .orderBy('inicio', 'asc')
      .onSnapshot((snapshot) => {
        const data = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }))
        setSectores(data)
      })
  }, [competicionId])

  /**
   * Listen the result updates of the favorite participants.
   */
  useEffect(() => {
    const favoritos = cookie.load('favoritos-' + competicionId)
    // setFavoritos(favoritos)

    if (favoritos && favoritos.length) {
      const unlistenList = []
      favoritos.forEach(dorsal => {
        dorsal = parseInt(dorsal, 10)
        unlistenList.push(
          // Subscribe to the changes in each result (dorsal).
          firestore.doc('resultado/' + competicionId + '-' + dorsal).onSnapshot(snapshot => {
            const doc = snapshot ? snapshot.data() : null
            let encontrado = resultados.filter(a => parseInt(a.dorsal, 10) === dorsal)
            encontrado = encontrado.length ? encontrado[0] : null
            if (doc) {
              // Replace or insert updated remote data
              if (encontrado) {
                resultados[resultados.indexOf(encontrado)] = doc
              } else {
                resultados.push(doc)
              }
            } else {
              // Removed result
              if (encontrado) {
                resultados.splice(resultados.indexOf(encontrado), 1)
              }
            }
            setResultados(resultados)
          })
        )
      })

      return () => {
        unlistenList.map(f => f())
      }
    }
  }, [competicionId])

  /**
   * Build the map rendering data.
   * It depends on competicion.mapa_geojson, competicion.mapa_visible and
   * changes in meta control ...
   */
  useEffect(() => {
    // console.info(['useEffect [competicion, controles, sectores]'])
    if (competicion && competicion.mapa_visible) {
      if (competicion.mapa_geojson && controles && controles.length) {
        const data = JSON.parse(competicion.mapa_geojson)
        // console.info(data)
        const coordsGeo = data.features[0].geometry.coordinates.map(
          r => [r[1], r[0]]
        )
        const _turfLine = lineString(coordsGeo)
        const _turfBounds = bbox(_turfLine)
        let turfDistance = lineDistance(_turfLine) * 1000.0

        const distanciaInicio = getPrevisionInicioDistancia(
          competicion, controles
        )
        if (controlMeta && turfDistance) {
          setTurfDistanceRelation((controlMeta.distancia - distanciaInicio) / turfDistance)
        }
        setGeoJson(coordsGeo)
        setTurfLine(_turfLine)
        setTurfBounds(_turfBounds)
      } else {
        let _totalLine = []
        const _sectores = sectores
          .filter(s => s.mapa_geojson)
          .map(s => {
            let geo = JSON.parse(s.mapa_geojson)
            geo = geo.features[0].geometry.coordinates.map(
              r => [r[1], r[0]]
            )
            const line = lineString(geo)
            turfLine.push(line)
            s.distanciaGeo = lineDistance(line) * 1000.0
            _totalLine = _totalLine.concat(geo)
            // console.info(totalLine)
            s.inicio_metros = 0.0
            if (s.inicio) {
              const inicio = getControlById(controles, s.inicio)
              if (inicio) {
                s.inicio_metros = inicio.distancia
              }
            }
            const fin = getControlById(controles, s.fin)
            s.fin_metros = fin.distancia
            s.distancia = s.fin_metros - s.inicio_metros
            s.turfDistanceRelation = s.distancia / s.distanciaGeo
            return s
          })
        const _turfBounds = bbox(lineString(_totalLine))
        setTurfBounds(_turfBounds)
        setSectoresFiltrados(_sectores)
      }
    }
  }, [
    competicion.mapa_geojson,
    competicion.mapa_visible,
    JSON.stringify(sectores.map((s) => { return {id: s.id, mapa: s.mapa_geojson} })),
    JSON.stringify(controles.map((c) => { return {id: c.id, distancia: c.distancia, tipo: c.tipo} }))
  ])

  console.info('RENDER')
  // console.info(geoJson)

  if (competicion) {
    return <div>
      <TopHeaderMenu
        onClickBack={onClickBack}
        onClickShare={toogleSharePanel}
        competicion={competicion}
        evento={evento}
      />
      <CompeticionHeaderMenu
        competicion={competicion}
        selected={3}
        evento={evento}
      />
      {competicion.visible && (
        <div>
          <ControlSelector
            controlList={[]}
            competicion={competicion}
          />
          <ResultadoFavoritosList
            resultados={resultados}
            competicion={competicion}
            controles={controles}
            sectores={sectoresFiltrados}
            geoJson={geoJson}
            turfLine={turfLine}
            turfBounds={turfBounds}
            turfDistanceRelation={turfDistanceRelation}
          />

          {showSharePanel && (
            <SharePanel
              close={toogleSharePanel}
              url={`/competicion/${competicion.id}/favoritos`}
              title={`Progreso de tus favoritos en vivo en la prueba ${competicion.nombre} en ${evento.nombre}`}
            />
          )}
        </div>
      )}
    </div>
  } else {
    return <MsgNetLoading />
  }
}

/*
class FavoritosScreen extends React.Component {
  // ..
  constructor (props) {
    super(props)
    this.state = {
      favoritos: [],
      resultados: [],
      controles: [],
      competicion: null,
      sectores: [],
      evento: null,
      showSharePanel: false
    }
    this.unlisten = {
      resultados: []
    }
  }

  toogleSharePanel () {
    this.setState(state => ({
      showSharePanel: !this.state.showSharePanel
    }))
  }

  componentDidMount () {
    const { firestore } = this.props

    const competicionId = parseInt(this.props.match.params.competicionId, 10)
    this.unlisten.competicion = firestore.doc('competicion/' + competicionId).onSnapshot(snapshot => {
      let competicion = snapshot ? snapshot.data() : null
      if (competicion) {
        competicion.id = snapshot.id
      }
      this.setState({ competicion })
    })

    this.unlisten.controles = firestore.collection('control/')
      .where('competicion_id', '==', competicionId)
      .where('visible', '==', true)
      .orderBy('distancia', 'asc')
      .onSnapshot((snapshot) => {
        let controles = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }))
        this.setState({ controles })
      })

    this.unlisten.sectores = firestore.collection('sector/')
      .where('competicion_id', '==', competicionId)
      .orderBy('inicio', 'asc')
      .onSnapshot((snapshot) => {
        let sectores = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }))
        this.setState({ sectores })
      })

    const favoritos = cookie.load('favoritos-' + competicionId)

    if (favoritos) {
      this.setState({ favoritos })
      favoritos.forEach(dorsal => {
        dorsal = parseInt(dorsal, 10)
        this.unlisten.resultados.push(
          firestore.doc('resultado/' + competicionId + '-' + dorsal).onSnapshot(snapshot => {
            let resultados = this.state.resultados
            const doc = snapshot ? snapshot.data() : null
            let encontrado = resultados.filter(a => parseInt(a.dorsal, 10) === dorsal)
            encontrado = encontrado.length ? encontrado[0] : null
            if (doc) {
              if (encontrado) {
                resultados[resultados.indexOf(encontrado)] = doc
              } else {
                resultados.push(doc)
              }
            } else {
              // ¿eliminado?
              if (encontrado) {
                resultados.splice(resultados.indexOf(encontrado), 1)
              }
            }
            // resultados.sort((a, b) => a.puesto > b.puesto)
            this.setState({ resultados })
          })
        )
      })
    }
  }

  UNSAFE_componentWillUpdate (nextProps, nextState) { // eslint-disable-line
    if (this.state.competicion !== nextState.competicion) {
      if (nextState.competicion) {
        // Obtenemos el evento
        this.unlisten.evento = this.props.firestore.doc('evento/' + nextState.competicion.evento_id).onSnapshot(snapshot => {
          let evento = snapshot ? snapshot.data() : null
          if (evento) {
            evento.id = snapshot.id
          }
          this.setState({ evento })
        })
      }
    }
  }

  onClickBack () {
    this.props.history.push(`/${this.state.competicion.evento_id}`)
  }

  componentWillUnmount () {
    // Desconectamos todos os "listeners" de firestore para evitar problemas de memoria
    if (this.unlisten.evento) {
      this.unlisten.evento()
    }
    if (this.unlisten.competicion) {
      this.unlisten.competicion()
    }
    if (this.unlisten.controles) {
      this.unlisten.controles()
    }
    if (this.unlisten.sectores) {
      this.unlisten.sectores()
    }
    if (this.unlisten.resultados) {
      this.unlisten.resultados.forEach((o) => o())
    }
  }

  render () {
    console.info('RENDER')
    const evento = this.state.evento
    const sectores = this.state.sectores
    const competicion = this.state.competicion

    let coordsGeo = []
    let sectoresFiltrados = []
    if (competicion) {
      let geoJson = null
      let turfLine = null
      let turfBounds = []
      let turfDistanceRelation = 1.0

      if (competicion.mapa_visible) {
        if (competicion.mapa_geojson) {
          geoJson = JSON.parse(competicion.mapa_geojson)
          coordsGeo = geoJson.features[0].geometry.coordinates.map(
            r => [r[1], r[0]]
          )
          // console.info(coordsGeo)
          // let coordsGeo = geoJson.features[0].geometry.coordinates
          turfLine = lineString(coordsGeo)
          turfBounds = bbox(turfLine)
          // Normalmente o track ten algo de error e mide mais que a distancia real.
          // Debemos coñecer a relación entre a distancia real e a do track para
          // aproximar o máximo a chegada a meta.
          let turfDistance = lineDistance(turfLine) * 1000.0
          let meta = this.state.controles.filter(c => c.tipo === 'META')
          const distanciaInicio = getPrevisionInicioDistancia(
            competicion, this.state.controles
          )
          if (meta && meta.length && turfDistance) {
            turfDistanceRelation = (meta[0].distancia - distanciaInicio) / turfDistance
          }
        } else {
          turfLine = []
          let totalLine = []
          turfDistanceRelation = []
          sectoresFiltrados = sectores
            .filter(s => s.mapa_geojson)
            .map(s => {
              let geo = JSON.parse(s.mapa_geojson)
              geo = geo.features[0].geometry.coordinates.map(
                r => [r[1], r[0]]
              )
              coordsGeo.push(geo)
              const line = lineString(geo)
              turfLine.push(line)
              s.distanciaGeo = lineDistance(line) * 1000.0
              totalLine = totalLine.concat(geo)
              // console.info(totalLine)
              s.inicio_metros = 0.0
              if (s.inicio) {
                const inicio = getControlById(this.state.controles, s.inicio)
                if (inicio) {
                  s.inicio_metros = inicio.distancia
                }
              }
              const fin = getControlById(this.state.controles, s.fin)
              s.fin_metros = fin.distancia
              s.distancia = s.fin_metros - s.inicio_metros
              s.turfDistanceRelation = s.distancia / s.distanciaGeo
              return s
            })
          turfBounds = bbox(lineString(totalLine))
          // console.info(sectoresFiltrados)
        }
      }

      // geoJson = JSON.parse(competicion.mapa_geojson)
      // coordsGeo = geoJson.features[0].geometry.coordinates.map(r => [r[1], r[0]])
      // turfLine = lineString(coordsGeo)
      // turfBounds = bbox(turfLine)
      // console.info(coordsGeo)

      return <div>
        <TopHeaderMenu
          onClickBack={this.onClickBack.bind(this)}
          onClickShare={this.toogleSharePanel.bind(this)}
          competicion={this.state.competicion}
          evento={this.state.evento}
        />
        <CompeticionHeaderMenu
          competicion={this.state.competicion} selected={3}
          evento={this.state.evento}
        />
        {this.state.competicion.visible && (
          <div>
            <ControlSelector
              controlList={[]}
              competicion={this.state.competicion}
            />
            <ResultadoFavoritosList
              resultados={this.state.resultados}
              competicion={this.state.competicion}
              controles={this.state.controles}
              sectores={sectoresFiltrados}
              geoJson={coordsGeo}
              turfLine={turfLine}
              turfBounds={turfBounds}
              turfDistanceRelation={turfDistanceRelation}
            />

            {this.state.showSharePanel && (
              <SharePanel
                close={this.toogleSharePanel.bind(this)}
                url={`/competicion/${competicion.id}/favoritos`}
                title={`Progreso de tus favoritos en vivo en la prueba ${competicion.nombre} en ${evento.nombre}`}
              />
            )}
          </div>
        )}
      </div>
    } else {
      return <MsgNetLoading />
    }
  }
}
*/
export default withFirestore(FavoritosScreen2)



// WEBPACK FOOTER //
// ./src/containers/FavoritosScreen.js